export default __webpack_public_path__ + "static/media/tengen.c4ce83db.png";